import Slider from "react-slick";
import {Link} from "react-router-dom"
import ApplyModal from "./ApplyModal";
function Recruitment() {
    const FeedBacks = [{
        title: "JO nói về SOJO",
        content: "Tôi rất may mắn khi làm việc tại một văn phòng được thiết kế theo concept khách sạn SOJO. Điều này giúp tôi có sự thấu hiểu sâu sắc về thương hiệu mà tôi và những cá nhân khác đang nỗ lực xây dựng, phát triển. SOJO cũng là nơi khiến tôi nhận ra những giá trị bản thân, những tiềm năng ẩn dấu của chính mình mà tôi chưa từng nghĩ tới.",
        image: "/images/Mr_Son.png",
        author: "Mr-Sơn-ban hành chính"
    }, {
        title: "JO nói về SOJO",
        content: "Tôi rất may mắn khi làm việc tại một văn phòng được thiết kế theo concept khách sạn SOJO. Điều này giúp tôi có sự thấu hiểu sâu sắc về thương hiệu mà tôi và những cá nhân khác đang nỗ lực xây dựng, phát triển. SOJO cũng là nơi khiến tôi nhận ra những giá trị bản thân, những tiềm năng ẩn dấu của chính mình mà tôi chưa từng nghĩ tới.",
        image: "/images/Mr_Son.png",
        author: "Mr-Sơn-ban hành chính"
    }, {
        title: "JO nói về SOJO",
        content: "Tôi rất may mắn khi làm việc tại một văn phòng được thiết kế theo concept khách sạn SOJO. Điều này giúp tôi có sự thấu hiểu sâu sắc về thương hiệu mà tôi và những cá nhân khác đang nỗ lực xây dựng, phát triển. SOJO cũng là nơi khiến tôi nhận ra những giá trị bản thân, những tiềm năng ẩn dấu của chính mình mà tôi chưa từng nghĩ tới.",
        image: "/images/Mr_Son.png",
        author: "Mr-Sơn-ban hành chính"
    }, {
        title: "JO nói về SOJO",
        content: "Tôi rất may mắn khi làm việc tại một văn phòng được thiết kế theo concept khách sạn SOJO. Điều này giúp tôi có sự thấu hiểu sâu sắc về thương hiệu mà tôi và những cá nhân khác đang nỗ lực xây dựng, phát triển. SOJO cũng là nơi khiến tôi nhận ra những giá trị bản thân, những tiềm năng ẩn dấu của chính mình mà tôi chưa từng nghĩ tới.",
        image: "/images/Mr_Son.png",
        author: "Mr-Sơn-ban hành chính"
    },]
    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        prevArrow: (
            <div>
                <img src="/images/left-circle.png" />
            </div>
        ),
        nextArrow: (
            <div>
                <img src="/images/right-circle.png" />
            </div>
        ),
        responsive: [{
            breakpoint: 768,
            settings: {
                arrows:false
            }
        },]
    };
    const whyChooseMandala = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow:3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [{
            breakpoint: 767,
            settings: {
                slidesToShow:1
            }
        },]
    };
    return (
        <div className="recruitment">
            <h5 className="title">
                Thêm năng lượng - Sống thời thượng - Vui không tưởng
            </h5>
            <div className="aboutRecruitment">
                <div className="container">
                    <div className="row rowBox">
                        <div className="col-lg-6 col-12 col-md-6 colBox">
                            <h5 className="titleRecruitment">Về Mandala</h5>
                            <p>Từ khát vọng nâng tầm du lịch Việt Nam, SOJO Hotels là mô hình khách sạn thuận ích đầu tiên mang lại cho khách hàng những giá trị trải nghiệm du lịch hấp dẫn, tinh gọn mà tinh tế.</p>
                            <p>Giá trị trải nghiệm khác biệt này đến từ nguồn nhân lực - yếu tố mà SOJO luôn đề cao và đầu tư phát triển trước tiên. Chính vì vậy, mục tiêu tuyển dụng của SOJO không chỉ nằm ở thu hút ứng viên mà còn chào đón tất cả những ứng viên mong muốn làm việc trong một môi trường trẻ, năng động, sáng tạo và hiệu quả - nơi mỗi cá nhân có thể phát huy tối đa khả năng, cơ hội nâng cao nghiệp vụ và kiến thức chuyên môn.</p>

                        </div>
                        <div className='col-lg-6 col-12 col-md-6 colBox'>
                            <div className="contentBox" style={{ background: `url('/images/bgrre.jpg')` }}>
                                <h5>CÙNG Mandala, CÙNG BẠN - LÀM VẠN ĐIỀU KHÁC BIỆT !!!</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="feedbackRecruitment">
                <div className="container">
                    <Slider {...settings}>
                        {
                            FeedBacks.map(item => {
                                return (
                                    <div className="row rowBox">
                                        <div className="col-lg-6 col-12 col-md-6">
                                            <img className="img-fluid" src={item.image} alt="" />
                                        </div>
                                        <div className="col-lg-6 col-12 col-md-6">
                                            <h5 className="titleRecruitment">
                                                {item.title}
                                            </h5>
                                            <div className="content">
                                                {
                                                    item.content
                                                }
                                            </div>
                                            <div className="author">
                                                {item.author}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </Slider>
                </div>
            </div>
            <div className="whyChooseMandala">
                <div className="container">
                    <div className=" rowBox">
                        <Slider {...whyChooseMandala} >
                            <div className="colBox">
                                <div className="itemBox itemBox1">
                                    <img className="img-fluid" src="/images/phat-trien-ban-than.png" alt="" />
                                    <p>Phát triển bản thân toàn diện</p>
                                </div>
                            </div>
                            <div className="colBox">
                                <div className="itemBox itemBox2">
                                    <img className="img-fluid" src="/images/co-hoi-thang-tien.png" alt="" />
                                    <p>Phát triển bản thân toàn diện</p>
                                </div>
                            </div>
                            <div className=" colBox">
                                <div className="itemBox itemBox3">
                                    <img className="img-fluid" src="/images/van-hoa-doanh-nghiep.png" alt="" />
                                    <p>Phát triển bản thân toàn diện</p>
                                </div>
                            </div>
                        </Slider>
                        
                    </div>
                </div>
            </div>
            <div className="ambassadorShare">
                <div className="container">
                    <div className="row rowBox">
                        <div className="col-lg-7  col-md-7 col-12 colBox">
                            <img className="img-fluid image" src="/images/tuyen-dung-image-1.png" alt="" />
                            <h5 className="title">GURU không chỉ là một nhân viên Lễ tân hay nhân viên F&#38;B thông thường</h5>
                            <p>Tại khách sạn SOJO, GURU là một nhân sự đa năng, đa nhiệm về Dịch vụ khách hàng, lễ tân, quan hệ khách hàng, pha chế đồ uống, hậu cần và nhiều hơn nữa.</p>
                            <p className="textColor">
                                Bằng việc tham gia những khóa tuyển dụng và huấn luyện đặc biệt do SOJO thiết kế, GURU kết nối và trở thành những người bạn tin cậy, mang đến những hiểu biết sâu sắc về địa phương, trợ giúp và cung cấp tới khách hàng chính xác những gì khách hàng mong đợi.
                            </p>
                        </div>
                        <div className="col-lg-5 col-md-5 col-12 colBox">
                            <img className="img-fluid" src="/images/tuyen-dung-image.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="applyNow">
                <div className="container">
                    <div className="row rowBox">
                        <div className="col-lg-4 col-4 colBox" >
                            <div className="itemBox">
                                <p>Tổng số việc làm tuyển dụng</p>
                                <h5>50</h5>
                            </div>
                        </div>
                        <div className="col-lg-4 col-4 colBox" >
                            <div className="itemBox">
                                <p>Tổng số vị trí tuyển dụng</p>
                                <h5>20</h5>
                            </div>
                        </div>
                        <div className="col-lg-4 col-4 colBox" >
                            <div className="itemBox">
                                <p>Tổng số nơi làm việc</p>
                                <h5>3</h5>
                            </div>
                        </div>
                    </div>
                    <div className="btnApplyNow">
                        <ApplyModal />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Recruitment;